export enum ProductSortingTypes {
  CUSTOM = 'custom',
  ASCENDING_TITLE = 'asc_title',
  DESCENDING_TITLE = 'desc_title',
  ASCENDING_CREATION = 'asc_creation',
  DESCENDING_CREATION = 'desc_creation',
}
